import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { MyCONST } from '../../CONST/myConst';
import { Config, NgxPrintElementService } from 'ngx-print-element';
import { AlertesService } from "../../services/public/alertes.service";
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ViewDetailsSignataireComponent } from '../config-tribunal/configurations/signataires/view-details-signataire/view-details-signataire.component';
import { SignatairesService } from '../../services/frapper/signataires.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomService } from '../../services/frapper/custom.service';
import html2pdf from 'html2pdf.js';
import { CasierService } from '../../services/frapper/casier.service';

@Component({
  selector: 'app-visualize-casier',
  templateUrl: './visualize-casier.component.html',
  styleUrls: ['./visualize-casier.component.scss'],

})
export class VisualizeCasierComponent {
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  data: any;
  dataAllInformation: any;
  dataPiecesJointes: any = [];
  type: any;
  isMultiple: any;
  courriers: any[] = [];
  internesCourriers: any[] = [];
  internesPrincipals: any[] = [];
  isButtonDisabled: boolean = true;
  verification: String = MyCONST.DOMAIN + MyCONST.VERIFICATION_URI
  Tribunal: any = MyCONST.DETAIL_TRIBUNAL
  signature_gref: any
  signature_proc: any
  profil: string;
  @Input() parentModal: BsModalRef;
  isSignatureCasier: boolean = false;
  code: any
  my_tribunal: any = null
  selected_tribunal: any;
  imageFile: any = {}
  imageName: any = {}
  link: any
  @ViewChild('elementToPrint') printElement!: any;

  emptyInfractions: any = `
  <table class="table">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">First</th>
      <th scope="col">Last</th>
      <th scope="col">Handle</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td>Mark</td>
      <td>Otto</td>
      <td>@mdo</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>Jacob</td>
      <td>Thornton</td>
      <td>@fat</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td>Larry</td>
      <td>the Bird</td>
      <td>@twitter</td>
    </tr>
  </tbody>
</table>
  `



  constructor(private _formBuilder: FormBuilder, private options: ModalOptions,
    private alerte: AlertesService,
    public print: NgxPrintElementService,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private modalService: BsModalService,
    private defaultSignataireService: SignatairesService,
    private casierService: CasierService,
    private ngxService: NgxUiLoaderService,
    private customservice: CustomService,
  ) {
    this.data = this.options.initialState.data;
    this.type = this.options.initialState.type;
    this.isMultiple = this.options.initialState.isMultiple;
    try {
      let tribunal_information: any = JSON.parse(localStorage.getItem('my_tribunal'))
      if (tribunal_information.code) {
        this.code = tribunal_information.code
        this.Tribunal = tribunal_information.detail_tribunal
      }
    } catch (e) {
      console.log('ERROR ON GET TRIBUNAL====> ')
    }
  }

  activeSignatureCasier() {
    this.isSignatureCasier = !this.isSignatureCasier;
  }

  async getDefaulSignataire() {
    let filter = '[["tribunal" , "=","' + this.code + '"],["tag_documents" , "=","CASIER"]]'
    return (await this.defaultSignataireService.getAllDefaultsSignataires(filter)).data
  }

  async openModalSignataire() {
    const data = await this.getDefaulSignataire();
    const firstData = data[0]
    const config: ModalOptions = {
      initialState: {
        data: firstData,
      }
    }
    const modalRef = this.modalService.show(ViewDetailsSignataireComponent, Object.assign({}, config, { class: 'modal-xl ' }));
  }

  async generateCasierPDF(key: number) {
    this.ngxService.start()
    const element = this.printElement.nativeElement;

    const opt = {
      margin: 0.5,
      filename: 'casier.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };

    try {
      const pdfBlob: Blob = await html2pdf().set(opt).from(element).outputPdf('blob');

      const pdfFile = new File([pdfBlob], 'casier.pdf', { type: 'application/pdf' });
      const response = await this.createPiece(pdfFile, key);
      this.link = response?.message?.file_url || null;
      return this.link;
    } catch (err) {
      this.alerte.errorNotification('PDF', 'Échec de la génération ou de l\'envoi du PDF');
    } finally {
      this.ngxService.stop()
    }
  }

  createPiece(file: File | null, key: number): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!file) {
        this.alerte.errorNotification('Pie', 'Aucun fichier sélectionné!');
        return reject('Aucun fichier');
      }
      this.ngxService.startLoader('form_step');
      const formData1 = new FormData();
      formData1.append('is_private', '0');
      formData1.append('file', file);
      try {
        const res = await this.customservice.createFiles(formData1);
        this.imageFile[key] = res.message.file_url;
        this.ngxService.stopLoader('form_step');
        resolve(res);
      } catch (err) {
        this.ngxService.stopLoader('form_step');
        this.alerte.errorNotification('Pieces', 'Une erreur s\'est produite!');
        reject(err);
      }
    });
  }

  async confirm() {
    const key = 0;
    const pdfLink = await this.generateCasierPDF(key)
    const signataire = await this.getSignataires()
    const name = this.data.name
    let array_signataires = []
    for (const key in signataire) {
      if (Object.prototype.hasOwnProperty.call(signataire, key)) {
        const element = signataire[key];
        array_signataires.push({ nom_signataire: element.nom_signataire, email: element.email, telephone: element.telephone })
      }
    }
    const body_content = {
      'signataire': array_signataires,
      'send_signature_request': true,
      'document_pdf': pdfLink,
    }
    try {
      const response = (await this.casierService.updateCasier(name, body_content)).data
    } catch (error) {
      console.error('erreur dan confirm() ===> ', error)
    }
  }

  async getSignataires() {
    const data = await this.getDefaulSignataire()
    const document = (await this.defaultSignataireService.getOneDefaultSignataire(data[0].name)).data
    return document['signataire']
  }

  public config: Config = {
    printMode: 'template', // template-popup
    popupProperties: 'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,fullscreen=yes',
    pageTitle: 'casier',
    stylesheets: [],
    styles: [
      `
      .mypage {
  min-height: 297px;
  page-break-after: always;
}
      @page {
        size: A4;
        margin: 15;
        page-break-before: always;

      }
        @media print {


      /* Base styles */
      /* Base styles */
      body {
        margin: 15;
        padding: 10;

        background: #f0f0f0;
        font-family: 'Arial', sans-serif;
        // height: 100%;
          min-height: 297px; /* Ajustez la hauteur minimale selon vos besoins */
  page-break-after: always;
        page-break-before: always;
        tr{
          font-size: 11px;
        }

      }
        .mypage
          page-break-before: always;
        }

      /* Styles to ensure content fits A4 page size */


      header, .records-table, .stamps-and-verification, footer {
      padding: 10px;
      text-align: center;
      }

      header {
        border: none;
        padding: 10px;
        margin-top: 10px;
      }
      .header{
        display: flex;
        justify-content: space-between;
      }
        .document-container{
            min-height: 297px;
            page-break-before: always;
        }

      .left-aligned h1, .left-aligned h2, .left-aligned h3 {
        text-align: left;
        margin: 0;
        padding: 0;
      }

      .center-aligned h4, .center-aligned h5, .center-aligned p {
        text-align: center;
        margin: 0;
        padding: 0;
      }

      .center-aligned h4 {
        font-size: 18px;
        font-weight: bold;
        margin-top: 10px; /* Add space above the centered text */
      }

      .center-aligned h5 {
        font-size: 16px;
        margin: 5px 0;
      }

      .center-aligned p {
        font-size: 14px;
        margin: 5px 0;
      }


      hr {
        border: none;
        height: 1px;
        background-color: #000;
        margin: 5px auto; /* Center the horizontal line */
        width: 80%; /* Adjust as needed */
      }


      .content {
      display: flex;
      justify-content: space-between;
      margin-top: 10%;
      margin-bottom: 0px; /* Spacing before the table */
      }

      .mfooter{
        width:100%;
        margin:auto;
        display: flex;
        justify-content: space-between;
      }



      .greffe {
      flex-grow: 1;
      }

       .form {
        flex-grow: 1;
        margin-top: -25px;
        }

      .records-table table {
      width: 100%;
      border-collapse: collapse;



      }

      .records-table th, .records-table td {
      border: 1px solid #000;
      padding: 8px;
      text-align: center;
      }

      .records-table th {
      background-color: #cff4cf;
      }


      .field {
      margin-bottom: 5px;
      }

      .field label {
      display: block;
      margin-bottom: 0px;
      }
      .qr-code {
        width: 150px;       /* Définir la largeur */
        height: 150px;      /* Définir la hauteur */

        padding: 0px;      /* Ajouter du padding autour du QR Code (facultatif) */
        margin: 0px;       /* Ajouter des marges autour de l'image (facultatif) */
      }
      .field .input {
      border-bottom: 1px solid #000;
      text-align: center;
       font-size: 16px;
      width: 100%;
      height: 20px;
      }

      footer {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 10px;
        margin-top: 10px;
      }

      .stamps {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }



      .text-content {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        width: 60%;
      }

      .visa {
        text-align: center;
        margin-top: 0px;
        margin-left:20px;
      }
      .verification {
        text-align: left;
        margin-top: 0px;
        margin-left:20px;
      }

      .visa p, .verification p {
        margin: 0;
        padding: 0;
      }
      .mfooter{
        width:100%;
        margin:auto;
        display: flex;
        flex-direction: row
        justify-content: space-between;
      }

      @media (max-width: 768px) {

        .mfooter{
          width:100%;
          margin:auto;
          display: flex;
          flex-direction: row
          justify-content: space-between;
        }

        .text-content {
          flex-direction: row;
          align-items: flex-start;
        }

        .visa, .verification {
          text-align: left;
          margin-left: 0;
        }
        .content {
            flex-direction: row;
            margin-top: -4%;
          }
          .greffe {
            flex-grow: 1;
            }

             .form {
              flex-grow: 3;
              margin-top: -25px;
              }


          .greffe {
            margin-right: 0;
            margin-top: 20px;
            margin-bottom: 10px;
          }
          .myqr{
            margin-left: -20px;
          }
      }


      /* Print-specific styles */
      `
    ]
  }

  activePane = 0;

  onPrint2(el: any) {
    if (this.type == 'unprint') {
      this.alerte.warningNotification('Casier', 'Impossible d\'imprimer en mode apercu !')
    } else {
      try {
        this.print.print(el, this.config).subscribe(console.log);
      } catch (error) {
        console.log('dddddd==> ' + error);
      }
    }
  }


  ngOnInit() {
    this.signature_gref = MyCONST.API_URL + this.data.signature_greffe
    this.signature_proc = MyCONST.API_URL + this.data.signature_parquet
    console.log('thiss dataaaaa ======> ', this.data)
  }
  getFormattedDate(date): string {
    return this.datePipe.transform(date, 'dd-MM-yyyy');
  }
}


